import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const DirectoryIcon = props => (
    <SvgIcon {...props} width="19" height="18" viewBox="0 0 19 18">
        <path
            d="M9.50445 16.9813C9.16735 16.9813 8.84899 16.8504 8.61489 16.6074L1.873 9.87642C1.75127 9.75489 1.65763 9.62401 1.60145 9.46509C1.5359 9.31551 1.50781 9.14724 1.50781 8.97896C1.50781 8.81069 1.5359 8.65177 1.60145 8.49284C1.667 8.34327 1.76063 8.20304 1.873 8.08151L8.61489 1.36927C8.73662 1.24774 8.86771 1.15425 9.0269 1.09816C9.3359 0.96728 9.68236 0.96728 9.99136 1.09816C10.1412 1.1636 10.2816 1.25708 10.4034 1.36927L17.1453 8.1002C17.267 8.22173 17.3606 8.35261 17.4168 8.51154C17.4824 8.66111 17.5104 8.82939 17.5104 8.99766C17.5104 9.16594 17.4824 9.32486 17.4168 9.48379C17.3513 9.63336 17.2576 9.77359 17.1453 9.89512L10.4034 16.6261C10.1693 16.8598 9.85091 17 9.51381 17L9.50445 16.9813ZM9.50445 2.02366L9.3359 2.0891L2.59401 8.82004L2.52846 8.98831L2.59401 9.15659L9.3359 15.8875C9.42954 15.981 9.56999 15.981 9.66363 15.8875L16.4055 9.15659L16.4711 8.98831L16.4055 8.82004L9.67299 2.0891L9.50445 2.02366V2.02366Z"
            fill="currentColor"
        />
        <path
            d="M11.0024 10.858V8.98827H8.00601V11.2319H6.50781V8.24039C6.50781 7.82905 6.84491 7.49251 7.25691 7.49251H11.0024V5.6228L13.6243 8.24039L11.0024 10.858Z"
            fill="currentColor"
        />
    </SvgIcon>
);

export default DirectoryIcon;
